export default "__VITE_ASSET__B4nHMc5R__"